import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    Grid,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
    Typography
} from '@material-ui/core';
import { MyPATDialog } from '.';
import CustomInfoIcon from './CustomInfoIcon';
import rePublishQueueService from '../mylibrary/services/rePublishQueueService';
import LoaderComponent from './LoaderComponent';
import {createErrorSheet} from '../course-Management/helpers/helpers';
import Tooltip from '@material-ui/core/Tooltip';
const styles = createStyles({
    widthNoData: {
        width: 500,
        height: 'auto'
    },
    noDataText: {
        fontFamily: 'Roboto',
        fontSize: 24,
        lineHeight: '24px',
        textAlign: 'center',
        color: '#333333',
        margin: '0px 0px 10px'
    },
    noDataContainer: {
        padding: '13px 0px 20px',
        textAlign: 'center',
        '& img': {
            marginBottom: 34
        },
        '& .lightGray': {
            fontFamily: 'Roboto',
            fontSize: 16,
            lineHeight: '19px',
            color: '#999999'
        }
    },
    rePublishTooltip: {
        position: 'fixed',
        opacity: 0,
        marginRight: 60,
        '& :first-child': {
            whiteSpace: 'normal',
            width: 230,
            textAlign: 'left',
            marginTop: 44,
            marginRight: 40
        },
        '&::after': {
            position: 'absolute',
            width: 0,
            height: 0,
            bottom: -46,
            right: 60,
            borderLeft: '5px solid rgba(0, 0, 0, 0)',
            borderRight: '5px solid rgba(0, 0, 0, 0)',
            borderBottom: '12px solid rgb(0 0 0)',
            content: '""'
        }
    },
    whiteText: {
        color: 'rgb(255 255 255)',
    },

    inProgressText: {
        '&>:first-child': {
            fontSize: 14,
            color: 'rgb(255 0 0)',
            fontWeight: 600
        },
        margin: 6
    },

    marginBottom2x: {
        marginBottom: 16,
    },
    redColor: {
        color: '#F21D1D'
    },
    cancelBtn: {
        color: '#1D7DEA'
    },
    fontMD: {
        fontSize: 16,
        lineHeight: '24px',
        textAlign: 'center',
        color: '#666666'
    },
    okButton: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '19px',
        letterSpacing: '0.5px',
        color: '#FFFFFF',
        background: '#1D7DEA',
        padding: '4px 22px',
        maxWidth: 150,
        borderRadius: 4,
        margin: 0,
        '&:hover': {
            background: '#1D7DEA',
        },
    },

    navDetail: {
        background: '#ffffff !important',
        color: '#5a9ff1 !important',
    },

    detailIcon: {
        float: 'left'
    },

    marginTop1x: {
        marginTop: 6
    },

    popover_icon: {
        position: 'absolute',
        top: '42px !important',
        right: '240px !important',
        fill: '#ffffff !important',
        zindex: 9999
    },

    listItem: {
        fontSize: '1rem !important',
        height: '12px !important',
        color: '#666666 !important',
        textAlign: 'left',
        '& a': {
            paddingLeft: 10
        }
    },

    textGreyColor: {
        color: '#666666 !important'
    },

    rePublishBtn: {
        background: '#FFF',
        width: '100',
        marginRight: 6,
        border: '1px solid #1D7DEA',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
        color: '#1D7DEA'
    },

    disableBtn: {
        opacity: 0.5,
        border: '1px solid #1D7DEA',
        color: '#1D7DEA',
        '&:hover': {
            backgroundColor: '#1D7DEA !important',
        },
    },

    showHoverTooltip: {
        "&:hover": {
            "& + $rePublishTooltip": {
                opacity: 1
            }
        }
    },

    tableCell: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '18px',
        textAlign: 'center',
        color: 'rgb(51, 51, 51)'
    },
    borderNone: {
        border: 'none',
        height: 40
    },
    paddingSM: {
        padding: '4px 0px 0px',
        minWidth: 130,
        '&:last-child': {
            padding: '4px 0px 0px'
        }
    },
    tableRow: {
        height: 36,
        '&:nth-of-type(even)': {
            background: '#FBFBFB',
            border: '1px solid #E4E4E4'
        },
    },
    tableHead: {
        background: '#ECECEC',
        border: '1px solid #E4E4E4'
    },
    tableContainer: {
        width: '100%',
        position: 'absolute',
        height: '100%',
        overflowY: 'auto',
        borderRadius: 4,
        background: '#fff',
        margin: '-24px -24px',
        '& td': {
            borderBottom: '1px solid #E4E4E4',
            fontSize: 14,
            color: '#666666',
            padding: '10px 24px 10px'
        },
        '& tr:nth-child(even)': {
            background: 'rgb(249 249 249)',
            border: '1px solid #E4E4E4'
        }
    },
    widthSM: {
        maxWidth: 450
    },
    widthMd: {
        minWidth: 700,
        maxHeight: 450,
        minHeight: 230
    },
    truncateTxt:{
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp:2,
        whiteSpace: "normal",
        overflow: 'hidden'
    }
});

interface RePublishQueueProps extends WithStyles<typeof styles> {
    isDisable: boolean,
    isOpenRepublishDialog: boolean,
    handleRepublishQueue: Function,
    afterLoadQueueData: Function
}

interface RePublishQueueData {
    testId: string,
    questionId: string,
    finished: number,
    ongoing: number,
    fieldUpdated: string,
    type: string,
    queueId: string,
}


interface RePublishQueueDataState {
    isLoading: boolean,
    data: RePublishQueueData[]
}

interface RePublishQueueState {
    showTooltip: boolean,
    // isOpenRepublishDialog: boolean,
    isRemoveContainer: boolean,
    removeId: string,
    type: string,
    isTooltip: boolean,
    rePublishQueue: RePublishQueueDataState,
    isResultRegenarationInProgress: boolean,
    resultRegenarationInProgressIds: string
}

class RePublishQueue extends Component<RePublishQueueProps, RePublishQueueState>{
    constructor(props: RePublishQueueProps, state: RePublishQueueState) {
        super();
        let self = this;
        self.state = {
            showTooltip: false,
            // isOpenRepublishDialog: false,
            isRemoveContainer: false,
            isTooltip: false,
            removeId: '',
            type: '',
            rePublishQueue: {
                isLoading: false,
                data: []
            },
            isResultRegenarationInProgress: false,
            resultRegenarationInProgressIds: ''
        }
    }

    componentDidMount() {
        this.loadQueueData()
    }

    loadQueueData = () => {
        this.setState({
            rePublishQueue: {
                isLoading: true,
                data: []
            }
        })
        rePublishQueueService.fetchRePublishQueue().
            then((res: any) => {
                this.setState({
                    rePublishQueue: {
                        isLoading: false,
                        data: res
                    }
                }, () => {
                    
                    this.props.afterLoadQueueData(this.state.rePublishQueue.data.length > 0)
                
                })
            }).
            catch((err: any) => {
                console.error(err)
            })
    }

    removeQueueDataById = () => {
        rePublishQueueService.removeRePublishQueueId(this.state.removeId, {
            type: this.state.type
        }).
            then((res: any) => {
                this.setState({
                    rePublishQueue: {
                        isLoading: false,
                        data: res,
                    },
                    isRemoveContainer: false,
                })
                this.loadQueueData()
            }).
            catch((err: any) => {
                console.error(err)
            })
    }



    mouseHoverHandle = () => {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }

    handleRemoveDialogClose = () => {
        this.setState({
            isRemoveContainer: false
        })
    }

    handleDialogClose = () => {
        const {isOpenRepublishDialog} = this.props
        if (this.state.isRemoveContainer) {
            this.handleRemoveDialogClose()
        } else {
            this.props.handleRepublishQueue(!isOpenRepublishDialog)
            // this.setState({
            //     isOpenRepublishDialog: !this.state.isOpenRepublishDialog,
            // })
        }
    }

    handleRepublishAll = () => {
        const { rePublishQueue } = this.state;
        this.setState({
            ...this.state,
            rePublishQueue: {
                ...rePublishQueue,
                isLoading: true,
            }
        });
        rePublishQueueService.publishHoleQueue()
            .then((res: any) => {
                this.setState({
                    ...this.state,
                    rePublishQueue: {
                        ...rePublishQueue,
                        isLoading: false,
                    }
                });
                if (res.statusCode == 422) {
                    // this.loadQueueData()
                    if(res.responseObject.error){
                        const data:any[]=[];
                        res.responseObject.error.forEach((err:any)=>{
                          const obj:any={};
                          for(let key in err){
                              obj[key.toUpperCase()]=err[key];
                          }
                          data.push(obj);
                        })
                        if(data.length==res.responseObject.error.length){
                            createErrorSheet(data,'Result_Regeneration_Error_Report.xlsx');
                        }
                    }else{
                    this.setState({
                        isResultRegenarationInProgress: true,
                        resultRegenarationInProgressIds: res.responseObject.map((data: any) => {
                            return data.test.contentId
                        }).join(", ")
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                isResultRegenarationInProgress: false,
                                resultRegenarationInProgressIds: ''
                            })
                        }, 5000)
                    })
                  }
                } else {
                    this.loadQueueData()
                    this.props.handleRepublishQueue(false)
                    // this.setState({
                    //     isOpenRepublishDialog: false
                    // })
                }
            })
    }

    handleRemove = () => {
        this.removeQueueDataById()
    }

    handleRemoveQueue = (removeId: string, type: string) => {
        this.setState({
            isRemoveContainer: !this.state.isRemoveContainer,
            removeId,
            type
        })
    }

    rePublishQueueTable(classes: any) {
        const { rePublishQueue } = this.state;
        return (
            <>
                <Grid container alignItems="center">
                    <Grid className={(rePublishQueue.data.length === 0) ?
                        classes.widthNoData : classes.tableContainer}>
                        {
                            rePublishQueue.isLoading ?
                                <LoaderComponent />
                                :
                                rePublishQueue.data.length === 0 ?
                                    <Grid container justify="center" alignItems="center">
                                        <Grid item>
                                            <Grid className={classes.noDataContainer}>
                                                <img alt="no content" src="/assets/svg/myLibrary/noData.svg" />

                                                <Typography align="center" className={classes.noDataText}>No Data in Queue</Typography>
                                                <Typography align="center" className="lightGray">Please add some ou have to add </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid> :
                                    <>
                                        <Table>
                                            <TableHead classes={{ root: classes.tableHead }}>
                                                <TableRow classes={{ head: classes.tableRow }}>
                                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Test ID</TableCell>
                                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Q ID/Section</TableCell>
                                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Students Attempt</TableCell>
                                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Field Updated</TableCell>
                                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    rePublishQueue.data.map((queueData: RePublishQueueData) => {

                                                        return <TableRow key={1} classes={{ root: classes.tableRow }}>
                                                            <TableCell align="center">{queueData.testId}</TableCell>
                                                            <TableCell align="center">{queueData.questionId}</TableCell>
                                                            <TableCell align="center">{queueData.finished} Attempted, {queueData.ongoing} ongoing </TableCell>
                                                            <TableCell align="center">
                                                                <Tooltip title={queueData.fieldUpdated} placement="top-start">
                                                                    <span className={classes.truncateTxt}>{queueData.fieldUpdated}</span>
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Link
                                                                    component="button"
                                                                    variant="body2"
                                                                    underline="none"  
                                                                    onClick={() => { this.handleRemoveQueue(queueData.queueId,queueData.type)}}
                                                                    classes={{ root: classes.redColor }}
                                                                >
                                                                    Remove
                                        </Link>
                                                            </TableCell>
                                                        </TableRow>
                                                    })
                                                }



                                            </TableBody>
                                        </Table>
                                    </>
                        }

                    </Grid>

                </Grid>
            </>
        )
    }

    removeFromQueue = () => {
        const { classes } = this.props;
        return (
            <Typography variant="body1" className={classes.fontMD}>
                Are you sure you want to remove this content from the Queue. All the changes made to this content will be lost.
            </Typography>
        );
    }

    render() {
        let self = this;
        const { classes, isDisable, isOpenRepublishDialog } = this.props;
        const { /* isOpenRepublishDialog, */ isRemoveContainer, rePublishQueue,
            isResultRegenarationInProgress,
            resultRegenarationInProgressIds, isTooltip } = this.state;
        let isDisableRepublishAll = false;
        let ongoing = 0;
        rePublishQueue.data.length && rePublishQueue.data.forEach((queueData: RePublishQueueData) => {
            ongoing += queueData.ongoing
        })
        if (ongoing > 0) {
            isDisableRepublishAll = true;
        }
        return (
            <>
                {/* <Button aria-controls="simple-menu" aria-haspopup="true"
                    variant="outlined" color="primary"
                    classes={{ outlined: classes.rePublishBtn }}
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        this.props.handleRepublishQueue(!isOpenRepublishDialog, this.loadQueueData)
                        // this.setState({
                        //     isOpenRepublishDialog: !this.state.isOpenRepublishDialog
                        // }, () => {
                        //     if (this.state.isOpenRepublishDialog) {
                        //         this.loadQueueData();
                        //     }
                        // })
                    }}
                    onMouseOver={this.mouseHoverHandle.bind(this)}
                    onMouseOut={this.mouseHoverHandle.bind(this)}
                    z-index={9999}
                    disabled={(rePublishQueue.data.length == -1) && isDisable}
                >
                    Re-Publish Queue
            </Button> */}
                {
                    isOpenRepublishDialog &&
                    <MyPATDialog
                        dialogOpen={isOpenRepublishDialog}
                        dialogHasActions={true}
                        dialogHeading={(!isRemoveContainer && rePublishQueue.data.length > 0) ? "Re-Publish Queue (" + rePublishQueue.data.length + ")" : " "}
                        isAlignCenter={true}
                        customButtonVariant="withoutBorderCloseIcon"
                        onDialogClose={this.handleDialogClose.bind(this)}
                        isCustomBackground={(rePublishQueue.data.length > 0) ? false : isRemoveContainer}
                        isborderDialogAction={(rePublishQueue.data.length === 0 || isRemoveContainer) ? true : false}
                        otherDialogProps={{
                            fullWidth: false,
                            maxWidth: false
                        }}
                        customDialogActions={
                            <>
                                <Grid container justify="space-between" spacing={8} alignItems="center"
                                    className={isRemoveContainer ? classes.marginBottom2x : ''}>
                                    <Grid item>
                                        {!isRemoveContainer && isResultRegenarationInProgress && (rePublishQueue.data.length > 0) &&
                                            isResultRegenarationInProgress &&
                                            <Grid className={classes.inProgressText}>
                                                <Typography align="left" variant="body1">
                                                    Result Regeneration for Test IDs ({resultRegenarationInProgressIds}) is in progress. Please try after some time.
                                                </Typography>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item>
                                        {(rePublishQueue.data.length > 0) ?
                                            <>
                                                <Button onClick={this.handleDialogClose.bind(this)}
                                                    className={classes.cancelBtn}>Cancel</Button>
                                                {!isRemoveContainer ?
                                                    <>
                                                        {/* Added span tag as we can' use the hover state css when button is in Disable state */}
                                                        <span className={classes.showHoverTooltip}>
                                                            { rePublishQueue.isLoading ?
                                                            <LoaderComponent />
                                                            : <Button
                                                                onClick={this.handleRepublishAll.bind(this)}
                                                                disabled={isDisableRepublishAll}
                                                                classes={{
                                                                    disabled: classes.disableBtn,
                                                                    label: classes.whiteText,
                                                                    text: classes.whiteText,
                                                                    root: classes.okButton
                                                                }}>Re-Publish All</Button>}
                                                        </span>
                                                        {isDisableRepublishAll &&
                                                            <>
                                                                <span className={classes.rePublishTooltip}>
                                                                    <CustomInfoIcon
                                                                        isInfoIcon={false}
                                                                        isRightArrow={true}
                                                                        isCenterArrow={true}
                                                                        knowMoreAbout={false}
                                                                        details="One of the tests is being attempted by students at the moment. Please remove that test/question from the queue or try after some time."
                                                                        toolTipDirection="top" />
                                                                </span>
                                                            </>
                                                        }
                                                    </>
                                                    :
                                                    <Button onClick={this.handleRemove.bind(this)} className={classes.okButton}>Yes, Remove</Button>
                                                }
                                            </>
                                            :
                                            <Button
                                                onClick={this.handleDialogClose.bind(this)}
                                                disabled={isDisableRepublishAll}
                                                className={classes.okButton}>Ok</Button>
                                        }
                                    </Grid>
                                </Grid>
                            </>
                        }
                    >
                        <Grid container justify="center" alignItems="center"
                            className={(isRemoveContainer || rePublishQueue.data.length === 0)
                                ? classes.widthSM : classes.widthMd}>
                            {
                                (!isRemoveContainer && isOpenRepublishDialog) ?
                                    this.rePublishQueueTable(classes) : this.removeFromQueue()
                            }
                        </Grid>
                    </MyPATDialog>
                }
            </>
        );
    }
}

// @ts-ignore
export default withStyles(styles)(RePublishQueue);